const localState = {
    data: {},
    passwords: {
        pass: '',
        passConfirm: '',
    },
    adminFormData: {},
    request: {
        state: '',
        message: '',
    },
    adminRequests: [],
    newReqUser: {},
    isLast: false,
}

const checkIsLastPage = (v) => v !== 25

const actions = {
    async getAdminData({
        state,
    }) {
        try {
            const response = await this.$api.administrators.self()
            state.data = response.data

            const role = response.data.role !== undefined ? response.data.role.slug : 'client'
            window.$role = role

            localStorage.setItem('role', role)
        } catch (err) {
            console.log(err)
        }
    },
    async updateAdmin({
        state,
        commit,
    }) {
        try {
            state.request.state = 'loading'
            commit('adminForm', {
                data: state.data,
            })
            const response = await this.$api.administrators.updateSelf(state.adminFormData)
            setTimeout(() => {
                state.data = response.data
                state.request.message = 'Updated!'
                commit('updateStatus', 'success')
            }, 400)
        } catch (err) {
            console.log(err)
        }
    },
    async updateAdminImage({
        state,
    }, data) {
        state.request.state = 'loading'

        try {
            const response = await this.$api.administrators.updateImage(data)
            state.data = response.data
            state.request.state = ''
            state.request.message = ''
        } catch (err) {
            console.log(err)
        }
    },
    async getAdminRequests({
        state,
        commit,
    }, {
        page = 1,
    }) {
        const query = `?page=${page}`

        if (!state.isLast) {
            try {
                const response = await this.$api.orders.fetchRequests(query)
                commit('setAdminRequests', response.data.data)
                commit('setIsLastPage', checkIsLastPage(response.data.data.length))
            } catch (err) {
                // log err
            }
        }
    },
}
const mutations = {
    setState(state, {
        type,
        data,
    }) {
        state[type] = data
    },
    setAvatarAdmin(state, data) {
        state.data.big_image = data
        state.data.small_image = data
    },
    adminForm(state, {
        data,
    }) {
        const adminData = {
            first_name: data.first_name,
            last_name: data.last_name,
            phone: data.phone,
            email: data.email,
        }
        if (state.passwords.pass && state.passwords.passConfirm) {
            adminData.password = state.passwords.pass
            adminData.password_confirmation = state.passwords.passConfirm
            state.passwords.pass = ''
            state.passwords.passConfirm = ''
        }
        state.adminFormData = adminData
    },
    clearAdminRequests: (state, v) => {
        state.adminRequests = v
    },
    setAdminRequests(state, data) {
        if (state.adminRequests.length === 0) state.adminRequests = data
        else state.adminRequests = state.adminRequests.concat(data)
    },
    setNewReqUser(state, data) {
        state.newReqUser = data
    },
    updateStatus: (state, status) => {
        state.request.state = status
    },
    setIsLastPage: (state, v) => {
        state.isLast = v
    },
    clearLandingRequests: (state) => {
        state.isLast = null
        state.adminRequests = []
    },
}
const getters = {
    getRequestState: (state) => state.request,
    getAdminRequests: (state) => state.adminRequests,
    adminDataGetters: (state) => state.data,
    passwordsGetters: (state) => state.passwords,
    requestFailedGetters: (state) => state.request,
    formStatusGetters: (state) => state.request.state,
    adminPhotoGetters: (state) => state.data.small_image,
}

export default {
    state: localState,
    getters,
    actions,
    mutations,
}
